import Api from '.';

class TicketApi extends Api {
  base_endpoint = 'tickets';

  all() {
    return this.doRequest('get', `/`);
  }

  addComment(data) {
    return this.doRequest('post', `comment`, data);
  }
}

export default new TicketApi();
